import { defineStore } from 'pinia';
import { api } from '@services/AxiosBootstrap';

export const useMemberStore = defineStore('member', {
    state: () => {
        return {};
    },
    getters: { // like computed props
    },
    actions: { // like normal methods
        async getMember(uuid) {
            return await api.get(`member/v/${uuid}`);
        },
        async sendFeedback(uuid, payload) {
            const url = `member/v/${uuid}/unsubscribe-email/feedback`;
            return await api.post(url, payload);
        },
        async pauseSubscription(uuid, messageId) {
            const url = `member/v/${uuid}/pause-email/${messageId}`;
            return await api.post(url);
        },
        async updateCommunication(uuid, payload) {
            const url = `member/v/${uuid}/communication`;
            return await api.post(url, payload);
        },
        async updateMemberForm(uuid, payload) {
            const url = `member/v/${uuid}/info`;
            return await api.post(url, payload);
        },
        async unsubscribe(uuid, messageId) {
            let url = `member/v/${uuid}/unsubscribe-email`;

            if (messageId) {
                url = `${url}/${messageId}`
            }

            console.log(uuid, messageId);
            return await api.post(url);
        },
    },
});
